<template>
    <b-modal ref="mdlSimEdit" size="xl" :title="titoloModale" no-close-on-backdrop no-close-on-esc centered scrollable>
        <div class="sa-tab-scroll">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Iccid</span>
                    <b-form-input v-model="jsonDataSim.iccid" placeholder="Iccid..."> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Codice ean</span>
                    <b-form-input v-model="jsonDataSim.codiceEan" placeholder="Codice ean..."></b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Tipo</span>
                    <b-form-input v-model="jsonDataSim.tipo" placeholder="Tipo..."></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Stato attuale</span>
                    <b-form-select v-model="jsonDataSim.statoAttuale" :options="statoAttualeOptions" value-field="stato" text-field="stato"></b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Gestore</span>
                    <b-form-input v-model="jsonDataSim.gestore" placeholder="Gestore..."></b-form-input>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Numero</span>
                    <b-form-input v-model="jsonDataSim.numero" placeholder="Numero..."> </b-form-input>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Pin</span>
                    <b-form-input v-model="jsonDataSim.pin" placeholder="Pin..."> </b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <span class="sa-label-data">Puk</span>
                    <b-form-input v-model="jsonDataSim.puk" placeholder="Puk..."></b-form-input>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-button size="md" variant="outline-secondary" @click="onClickIndietro"> Annulla </b-button>

            <!--<b-button size="md" variant="outline-danger" @click="onClickAnnulla"> Annulla </b-button>-->

            <b-button variant="outline-success" @click="onSalvaSim"> Salva Sim </b-button>
        </template>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    name: "ConfigurazioneSimModalEditComponent",

    data() {
        return {
            titoloModale: "Modifica Sim",
            jsonDataSim: {
                id: "",
                iccid: "",
                codiceEan: "",
                tipo: "",
                statoAttuale: "",
                numero: "",
                pin: "",
                puk: "",
            },
            pathResource: "/devicesim",
            pathResourceStati: "/devicestati",
            statoAttualeOptions: [],
        };
    },
    mounted() {
        let me = this;
        me.loadDataOptionsStatoAttuale();
    },
    methods: {
        show(item) {
            let data = item
                ? Object.assign({}, item)
                : {
                      id: "-1",
                      iccid: "",
                      codiceEan: "",
                      tipo: "",
                      statoAttuale: "",
                      numero: "",
                      pin: "",
                      puk: "",
                      statoAttualeDataOra: "",
                  };
            this.jsonDataSim = data;
            this.titoloModale = data.id === "-1" ? "Nuova Sim" : "Modifica Sim";
            if (data.id === "-1" && this.statoAttualeOptions.length > 0) {
                this.jsonDataSim.statoAttuale = this.statoAttualeOptions[0].stato;
            }
            this.$refs.mdlSimEdit.show();
        },
        onClickIndietro() {
            this.$refs.mdlSimEdit.hide();
        },
        onSalvaSim() {
            let me = this;
            me.jsonDataSim.statoAttualeDataOra = new Date().getTime();
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataSim, me.loadDataSimSuccess, me.loadDataSimError);
        },
        loadDataSimSuccess() {
            this.$bvModal.msgBoxOk("Sim salvato con successo.", {
                title: "Salvataggio completato",
                size: "sm",
                okVariant: "success",
                centered: true,
            });
            this.$refs.mdlSimEdit.hide();
            this.$emit("afterSave");
        },
        loadDataSimError(error) {
            console.log("Errore nel salvataggio della voce menu:", error.response.data.messaggio);
        },
        loadDataOptionsStatoAttuale() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStati, {}, me.loadDataStatiSuccess, me.loadDataStatiError);
        },
        loadDataStatiSuccess(response) {
            let me = this;
            me.statoAttualeOptions = response.data.data.list;
        },
        loadDataStatiError(error) {
            console.log(error);
        },
    },
};
</script>
